import styled from 'styled-components';

import { toVw, toVwMobile, toVwTablet } from '../utils/styles';
import { FONT_SIZE_BIG } from '../constants';
import mq from '@/utils/media-queries';

const Styled = styled.div`
  font-size: ${toVw(FONT_SIZE_BIG)};
  font-weight: 300;

  ${mq.tablet(css`
    font-size: ${toVwTablet(FONT_SIZE_BIG)};
  `)};

  ${mq.mobile(css`
    font-size: ${toVwMobile(FONT_SIZE_BIG)};
  `)};
`;

export default Styled;



// WEBPACK FOOTER //
// ./src/components/BigText.js